import { BaseRemoteService } from "@ofqual/portal-core/core/dataAccess";
import {
  Opts,
  PagedResponse,
  QueryParams,
} from "@ofqual/portal-core/core/types";
import { paramsToSearchString } from "@ofqual/portal-core/core/utils/urlHelper";
import { Organisation } from "../domain/Organisation";

export class OrgsService extends BaseRemoteService {
  public async search(
    params: QueryParams,
    opts: Opts
  ): Promise<PagedResponse<Organisation>> {
    const url = `${this.apiRoot}/organisations/${paramsToSearchString(params)}`;
    const response = await super.getRequest<PagedResponse<Organisation>>(
      url,
      opts
    );
    return {
      ...response,
      data: response.data.sort((a, b) => (a.name < b.name ? -1 : 1)),
    };
  }

  public async getAll(opts: Opts): Promise<Organisation[]> {

    const url = `${this.apiRoot}/organisations/${paramsToSearchString({
      pageSize: 999,
      filter: "excludePendingRecognition"
    })}`;
    const response = await super.getRequest<PagedResponse<Organisation>>(
      url,
      opts
    );
    return response.data.sort((a, b) => (a.name < b.name ? -1 : 1));
  }
}
